import { MutationTree } from 'vuex';
import { IN2kState, IN2kOnDevice } from './types';
import { IN2KFluidLevelEvent, IN2KGnssEvent, IN2KHeadingEvent, IN2KRudderEvent, IN2KSpeedEvent,
    IN2KTemperatureEvent, IN2KWaterDepthEvent, IN2KWindEvent, IN2KOutsideEnvironmentalEvent } from '@/common/apis/DeviceApi';
import Vue from 'vue';

function getDeviceState(state: IN2kState, deviceNumber: string): IN2kOnDevice {
    let deviceState = state.devices[deviceNumber];
    if (!deviceState) {
        deviceState = {
            temperature: {},
            heading: {},
            speed: {},
            fluid: {},
            wind: {},
            gnss: {},
        };
        Vue.set(state.devices, deviceNumber, deviceState);
    }
    return deviceState;
}

export const mutations: MutationTree<IN2kState> = {
    clear(state) {
        Vue.set(state, 'devices', []);
    },
    fluidLevelUpdate(state, evt: IN2KFluidLevelEvent) {
        if (!evt.deviceNumber || !evt.type) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.fluid, evt.type, evt);
    },
    gnssUpdate(state, evt: IN2KGnssEvent) {
        if (!evt.deviceNumber || !evt.type) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.gnss, evt.type, evt);
    },
    headingUpdate(state, evt: IN2KHeadingEvent) {
        if (!evt.deviceNumber || !evt.reference) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.heading, evt.reference, evt);
    },
    rudderUpdate(state, evt: IN2KRudderEvent) {
        if (!evt.deviceNumber) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState, 'rudder', evt);
    },
    speedUpdate(state, evt: IN2KSpeedEvent) {
        if (!evt.deviceNumber || !evt.reference) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.speed, evt.reference, evt);
    },
    temperatureUpdate(state, evt: IN2KTemperatureEvent) {
        if (!evt.deviceNumber || !evt.source) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.temperature, evt.source, evt);
    },
    waterDepthUpdate(state, evt: IN2KWaterDepthEvent) {
        if (!evt.deviceNumber) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState, 'waterDepth', evt);
    },
    windUpdate(state, evt: IN2KWindEvent) {
        if (!evt.deviceNumber || !evt.reference) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState.wind, evt.reference, evt);
    },
    outsideEnvironmentalUpdate(state, evt: IN2KOutsideEnvironmentalEvent) {
        if (!evt.deviceNumber) {
            return;
        }
        const deviceState = getDeviceState(state, evt.deviceNumber);
        Vue.set(deviceState, 'outsideEnvironmental', evt);
    },
};
